$(() => {
	window.notifyFancybox = function (html, t) {
		let informer = $('body').find('#modal_informer');
		if (informer.length < 1) {
			informer = $('<div class="modal_informer" id="modal_informer"></div>');
			informer.appendTo($('body'));
		}
		informer.html(html);
		$('<a href="#modal_informer"></a>').fancybox({
			 'autoScale': true,
			 'transitionIn': 'elastic',
			 'transitionOut': 'elastic',
			 'speedIn': 500,
			 'speedOut': 300,
			 'autoDimensions': true,
			 'centerOnScroll': true,
			 'href' : '#modal_informer'
		  }).click();
		  informer.find('form button[type="submit"]').on('click', function () {
			 $(this).closest('form').submit(); 
		  });
		  if (typeof t === 'number') {
			  setTimeout(function () {
				 $.fancybox.close();
				 informer.remove(); 
			  }, t);
		  }
	}
	$('body').on('click', 'a[data-api-type="popup-form"], .decor-frm-btn', function () {
		var modal = $('body').find('#orderModal').clone().removeAttr('id').removeAttr('style');
		if($(this).hasClass('decor-frm-btn')) {
			$(modal).find('input[name="title"]').val('Консультация специалиста');
		}
		notifyFancybox(modal[0].outerHTML);
		return false;
	}).on('submit', '.js-order-form, .js-calc-form', function () {
		let data = $(this).serialize() + '&ajax=1';
        let th = $(this);
        if (th.prop('send')) {
            return false;
        }
        th.prop('send', true);
        $.post('/ajax/mail.php', data).done(function(response) {
			th[0].reset();
			$.fancybox.close();
			notifyFancybox('<center>Благодарим за заявку, в ближайшее время с Вами свяжется наш специалист</center>');
            th.prop('send', false);
        }).fail(function(response) {
			$.fancybox.close();
            notifyFancybox('<center>Произошла ошибка, повторите попытку позднее</center>');
            
            console.log('error');
            th.prop('send', false);
        });
		return false;
	});
});